<template class="logbg">
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center" mt-2>
       
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 mt-2 >
	  <div class="bgwhite text-xs-center">
	   <h1>Customer Log In</h1>
	  <v-flex xs12 sm12  mt-3 topwhite>
	  <div class="circle"> <div class="innercircle"><v-icon class="lock">event</v-icon> </div> </div>
	 
	  </v-flex>
	  <div class="bgwhitenner">
        <form @submit.prevent="CheckandShowBooking">
          <v-layout column>
		  <v-flex>
		  <v-alert type="error" dismissible v-model="alert">
			{{ error }}
		  </v-alert>
		</v-flex>
            <v-flex>
              <v-text-field
			    type="number"
                name="bookingreference"
                label="Booking Reference"
                id="bookingreference"
				v-model="bookingreference"
				box
				prepend-icon="vpn_key"
                required></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="LastName"
                label="Last Name"
                id="LastName"
				v-model="LastName"
                type="text"
				prepend-icon="perm_identity"
				box
                required></v-text-field>
            </v-flex>
            <v-flex>
		<v-menu
        ref="bookdatemenu"
        :close-on-content-click="false"
        v-model="bookdatemenu"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <v-text-field 
		
          slot="activator"
          v-model="DepartureDate"
           name="DepartureDate"
		   hint="MM/DD/YYYY format"
           label="Departure Date"
           id="DepartureDate"
          prepend-icon="event"
		  box
          required
          
        ></v-text-field>
        <v-date-picker v-model="bookdate" no-title @input="bookdatemenu = false"></v-date-picker>
		</v-menu>
            </v-flex>
            <v-flex class="text-xs-center" >
              <v-btn id="submitform" type="submit" :disabled="loading">Login</v-btn>
            </v-flex>
			<v-flex class="text-xs-center" >
			<p>Can't find your booking details<br/><a href="/support">Contact Support</a></p>
			
			</v-flex>
          </v-layout>
        </form>
		</div>
		</div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
    data: () => ({
      bookdate: null,
      bookdatemenu: false,
	  bookingreference:'',
	  LastName:'',
	  alert: false
    }),
	computed: {
      DepartureDate () {
        return this.formatDate(this.bookdate)
      },
	  error () {
		return this.$store.state.error
	  },
	  loading () {
		return this.$store.state.loading
	  }
    },
	
	watch: {
  error (value) {
    if (value) {
      this.alert = true
    }
  },
  alert (value) {
    if (!value) {
      this.$store.commit('setError', null)
    }
  }
},

	methods: {
		formatDate (date) {
        if (!date) return null
        const [year, mon, day] = date.split('-');
        return `${day}/${mon}/${year}`;
      },
	  CheckandShowBooking () {
		this.$store.dispatch('CheckandShowBooking', { bookingreference: this.bookingreference, LastName: this.LastName, DepartureDate: this.DepartureDate })
	  }
    }
  }
</script>
